import React, { useState, useEffect, useContext } from 'react';
import { Divider, Icon } from 'antd';
import Select from 'react-select';
import moment from 'moment';
import _ from 'lodash';
import { FormContext } from '../metadata/MDForm';
import { ModelContext } from '../metadata/ModelSource';

const { Option } = Select;

export function YearPicker({ yearAttr, startYear, endYear, onChange, ...props }) {
  const fromYear = startYear ? startYear : moment().year();
  let range = 30;
  if (endYear) {
    if (fromYear - endYear > 0) {
      range = fromYear - endYear;
    }
  }
  const [options, setOptions] = useState([]);

  const form = useContext(FormContext);
  const model = useContext(ModelContext);
  const { setValueByAttr, getValueByAttr } = form;

  const previousValue = getValueByAttr(yearAttr);
  const [selectedOption, setSelectedOption] = useState(
    previousValue ? { value: previousValue, label: previousValue } : props.value
  );

  const handleChange = (selected) => {
    setValueByAttr(yearAttr, selected.value);
    setSelectedOption(selected);
    if (onChange) {
      onChange(selected.value);
    }
  };

  useEffect(() => {
    const yearOptions = _.times(range, (index) => {
      return {
        value: (fromYear - index).toString(),
        label: (fromYear - index).toString(),
      };
    });
    setOptions(yearOptions);
  }, []);

  return (
    <Select
      {...props}
      aria-label="Select"
      styles={customStyles}
      openMenuOnFocus
      placeholder={null}
      options={options}
      value={selectedOption}
      onChange={handleChange}
      components={{
        IndicatorSeparator: () => null,
      }}
      theme={(theme) => ({
        ...theme,
        borderRadius: 4,
        zIndex: 3,
        colors: {
          ...theme.colors,
          primary25: 'rgb(0, 115, 157, 0.1)',
          primary: 'rgba(0, 115, 157, 0.5)',
          neutral30: 'rgba(0, 115, 157, 0.5)',
        },
      })}
    />
  );
}

const customStyles = {
  control: (base) => ({
    ...base,
    '&:hover': {
      cursor: 'pointer',
    },
  }),
  menu: (styles) => ({ ...styles, zIndex: 999 }),
};
